export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-die-one-c78f77781e126c6645c32c0ee7c13dbc.svg";